import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "test-page" }

import FishText from '@/views/api'

import {ref} from "vue";

import TextWriteWindow from "@/components/TestWriteWindow/TextWriteWindow.vue";
import FormConstruct from "@/components/formConstruct/formConstruct.vue";
import {formSchemaType} from '@/components/formConstruct/formConstructor'

import {formDataFishTextRu, formDataFishTextEn} from "@/types/formData";
import {between, maxValue, numeric, required} from "@vuelidate/validators";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const isLang = (val: string) => ['Ru', 'En'].includes(val)

const formSchema: Array<formSchemaType> = [
  {
    name: 'lang',
    label: 'Выберите язык',
    type: 'select',
    placeholder: 'Количество предложений',
    default: '',
    options: {
      selectData: [
        {
          label: 'Ru',
          value: 'Ru'
        },
        {
          label: 'En',
          value: 'En'
        }
      ]
    }
  },
  {
    name: 'sentences',
    type: 'input',
    label: 'Количество предложений',
    default: '',
  }
]

const formValidation: object = {
  lang: {required, isLang},
  sentences: {maxValue, numeric, betweenValue: between(1, 15), required},
}

let textFromApi = ref('')
let isLoading = ref(true)
let isShowForm = ref(true)

function getText(data: { lang: string, sentences: string }) {
  isShowForm.value = false
  if (data.lang === 'Ru') {
    const formData: formDataFishTextRu = {
      type: 'sentence',
      number: data.sentences,
      format: 'json'
    }

    FishText.getFishTextRu(formData)
      .then(({data}) => {
        if (data.status !== 'success') {
          console.error('Ошибка получения данных')
          return
        }

        textFromApi.value = data.text
      })
      .finally(() => {
        isLoading.value = false
      })
      .catch((err) => console.error('Ошибка: ', err))

    return
  }

  const formData: formDataFishTextEn = {
    type: "all-meat",
    sentences: data.sentences
  }

  FishText.getFishTextEn(formData)
    .then(({data}) => {
      textFromApi.value = data[0]
    })
    .finally(() => {
      isLoading.value = false
    })
    .catch((err) => console.error('Ошибка: ', err))
}

function backToForm() {
  isShowForm.value = true
  isLoading.value = true
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isShowForm))
      ? (_openBlock(), _createBlock(FormConstruct, {
          key: 0,
          "form-schema": formSchema,
          "form-validation": formValidation,
          class: "modal-setup",
          onSendData: getText
        }))
      : (_openBlock(), _createBlock(TextWriteWindow, {
          key: 1,
          text: _unref(textFromApi).trim().split('') ,
          "is-loading": _unref(isLoading),
          onBackToForm: backToForm
        }, null, 8, ["text", "is-loading"]))
  ]))
}
}

})